import React from 'react';

import {
  GridItem,
  GridContainer,
} from '../generic';

import {
  ApplicationsList,
} from './components';

const ApplicationsListPage = () => (
  <GridContainer>
    <GridItem xs={12} sm={12} md={12}>
      <ApplicationsList />
    </GridItem>
  </GridContainer>
);

export default ApplicationsListPage;
